import React, { useEffect, useState } from "react";
import { api, formatRupiah, STAGE_META } from "../lib/api";
import { Card } from "../components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, LineChart, Line, CartesianGrid,
  FunnelChart, Funnel, LabelList, Cell } from "recharts";

const FUNNEL_COLORS = ["#064E3B","#065F46","#047857","#059669","#10B981","#34D399"];

export default function Reports() {
  const [summary, setSummary] = useState(null);
  const [funnel, setFunnel] = useState([]);

  useEffect(() => {
    api.get("/dashboard/summary").then((r)=>setSummary(r.data));
    api.get("/reports/funnel").then((r)=>setFunnel(r.data));
  }, []);

  if (!summary) return <div className="text-slate-500">Memuat...</div>;

  const funnelData = funnel.map((f, i) => ({ name: STAGE_META[f.stage]?.id || f.stage, value: f.count || 0.1, fill: FUNNEL_COLORS[i] }));
  const totalRevenue = summary.revenue;
  const conversion = summary.total_leads > 0 ? Math.round((summary.won_deals / summary.total_leads) * 100) : 0;

  return (
    <div className="space-y-5" data-testid="reports-page">
      <div>
        <h1 className="text-2xl font-bold" style={{fontFamily:"Outfit"}}>Laporan</h1>
        <p className="text-sm text-slate-500">Analisis performa penjualan dan konversi.</p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Card className="p-5"><div className="text-xs text-slate-500 uppercase">Total Revenue</div><div className="text-2xl font-bold text-emerald-800 mt-1">{formatRupiah(totalRevenue)}</div></Card>
        <Card className="p-5"><div className="text-xs text-slate-500 uppercase">Konversi Lead → Won</div><div className="text-2xl font-bold text-slate-900 mt-1">{conversion}%</div></Card>
        <Card className="p-5"><div className="text-xs text-slate-500 uppercase">Pipeline Weighted</div><div className="text-2xl font-bold text-slate-900 mt-1">{formatRupiah(summary.weighted_pipeline)}</div></Card>
        <Card className="p-5"><div className="text-xs text-slate-500 uppercase">Won Deals</div><div className="text-2xl font-bold text-slate-900 mt-1">{summary.won_deals}</div></Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <Card className="p-5">
          <h3 className="text-lg font-semibold mb-4" style={{fontFamily:"Outfit"}}>Sales Funnel</h3>
          <ResponsiveContainer width="100%" height={320}>
            <FunnelChart>
              <Tooltip />
              <Funnel dataKey="value" data={funnelData} isAnimationActive>
                <LabelList position="right" dataKey="name" stroke="none" fill="#0F172A" fontSize={12} />
                {funnelData.map((d,i)=><Cell key={i} fill={d.fill}/>)}
              </Funnel>
            </FunnelChart>
          </ResponsiveContainer>
        </Card>

        <Card className="p-5">
          <h3 className="text-lg font-semibold mb-4" style={{fontFamily:"Outfit"}}>Pendapatan Bulanan</h3>
          <ResponsiveContainer width="100%" height={320}>
            <LineChart data={summary.monthly_revenue}>
              <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0"/>
              <XAxis dataKey="month" tick={{fontSize:11}} />
              <YAxis tick={{fontSize:11}} tickFormatter={(v)=>`${Math.round(v/1_000_000)}M`}/>
              <Tooltip formatter={(v)=>formatRupiah(v)}/>
              <Line type="monotone" dataKey="value" stroke="#059669" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </Card>
      </div>

      <Card className="p-5">
        <h3 className="text-lg font-semibold mb-4" style={{fontFamily:"Outfit"}}>Sales Performance</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 uppercase border-b"><tr><th className="text-left py-2">Sales</th><th>Leads</th><th>Deals</th><th>Won</th><th>Lost</th><th>Konversi</th><th className="text-right pr-2">Pendapatan</th></tr></thead>
            <tbody>
              {summary.sales_performance.map((s)=>(
                <tr key={s.user_id} className="border-b last:border-0" data-testid={`sales-perf-${s.user_id}`}>
                  <td className="py-2 font-medium">{s.name}</td><td className="text-center">{s.leads}</td>
                  <td className="text-center">{s.deals}</td><td className="text-center text-emerald-700">{s.won}</td>
                  <td className="text-center text-rose-600">{s.lost}</td><td className="text-center">{s.conversion}%</td>
                  <td className="text-right pr-2 font-semibold">{formatRupiah(s.revenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
